import { useState } from 'react';
import '../styles/components/AboutOwnerSection.css';

export default function AboutOwnerSection() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="about">
      <div className="container">
        <div className="about-text">
          <h2>O osnivaču</h2>
          <p>
            <strong>Zdravo, ja sam Marija Krsmanović – psiholog i osnivač Centra Clarity.</strong>
          </p>
          <p>
            U svom radu spajam savremene psihološke pristupe sa iskrenom ljudskom povezanošću. 
            Koristim znanja iz kliničke psihologije, KBT, ACT, kao i Compassion Focused Therapy (CFT) – 
            kako bih svakom klijentu pristupila pažljivo, sa razumevanjem i podrškom.
          </p>
          <p>
            Posebno me pokreće rad sa ljudima koji se suočavaju sa posledicama teških životnih iskustava, 
            osećajem zaglavljenosti ili strahovima, potragom za smislom ili ljudima koji jednostavno žele da 
            bolje razumeju sebe.
          </p>
          <p>
            Moje savetovanje se temelji na empatiji i autentičnosti – uz poštovanje tempa i potreba 
            svakog pojedinca. 
          </p>
          <p>
            Pored individualnog rada, rado sarađujem i sa kompanijama – pružajući psihološku podršku timovima, 
            liderima i organizacijama.
          </p>
          <p>
            Dobrodošli ste baš takvi kakvi jeste.
          </p>

          <button className="about-btn" onClick={() => setIsOpen(true)}>
            Obrazovanje i sertifikacije
          </button>
        </div>
      </div>

      {/* Popup Modal */}
      {isOpen && (
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Profesionalno iskustvo</h3>
            <ul>
              <li>Preko 15 godina iskustva, iz različitih oblasti primenjene psihologije</li>
              <li>Diplomirani psiholog – Filozofski fakultet u Novom Sadu (1997–2003)</li>
              <li>Klinička psihologija – Filozofski fakultet u Novom Sadu (2004–2006)</li>
              <li>Psihoterapija – REBT centar (2003–2004)</li>
              <li>Training of Users Seminar on the Istanbul Protocol - IRTC (2007)</li>
              <li>Prikupljanje i dokumentovanje psiholoških dokaza torture – IAN (2009)</li>
              <li>Trening iz KBT i grupnog rada – London Community Rehabilitation Company (2011)</li>
              <li>Osnovni i napredni ACT trening – Centar za KBT (2021)</li>
              <li>Compassion Focused Therapy – Centar za KBT (2021)</li>
              <li>
                Primarni i napredni nivo iz Kognitivno-bihejvioralne terapije, pod supervizijom za njenu primenu po standardima Evropske asocijacije za bihejvioralne i kognitivne terapije (EABCT) 
              </li>
            </ul>
            <button className="close-btn" onClick={() => setIsOpen(false)}>
              Zatvori
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
